function updateHeaderHeight() {
  const header = document.querySelector('.header-section');
  if (!header) return;

  const height = header.offsetHeight - 2; 
  document.documentElement.style.setProperty('--header-height', `${height}px`);
}

window.addEventListener('DOMContentLoaded', updateHeaderHeight)

window.addEventListener('resize', updateHeaderHeight);




const btn = document.getElementById("ProductSubmitButton-template--25326739194179__product-form");
const footer = document.querySelector("footer");

// Crea il clone
const btnClone = btn.cloneNode(true);
btnClone.id = "fixed-btn-mobile"
btnClone.style.position = "fixed";
btnClone.style.bottom = "20px";
btnClone.style.left = btn.getBoundingClientRect().left + "px";
btnClone.style.width = btn.offsetWidth + "px";
btnClone.style.zIndex = 9999;
document.body.appendChild(btnClone);

function updateButtonPosition() {
  const scrollY = window.scrollY;
  const btnTop = btn.getBoundingClientRect().top + scrollY;
  const footerTop = footer.getBoundingClientRect().top + scrollY;

  if (scrollY > btnTop && scrollY + window.innerHeight < footerTop) {
    // Mostra clone fixed
    btnClone.classList.add('active')
  } else {
    // Nascondi clone
    btnClone.classList.remove('active')
  }
}

window.addEventListener("scroll", updateButtonPosition);
window.addEventListener("resize", () => {
  // Aggiorna posizione e larghezza del clone
  btnClone.style.left = btn.getBoundingClientRect().left + "px";
  btnClone.style.width = btn.offsetWidth + "px";
});
